import { ConfidenceType, HighlightedMappingMapType, RowIdType } from '../../../../../../types';
import createColorGradient from '../../../../../../utils/colorGradients';

const getColorFromConfidence = createColorGradient();

type GetImportDescriptorStylingReturnType = {
    styles: Record<string, string>;
    classes: string;
};

export function getImportDescriptorStyling(
    confidence: ConfidenceType,
    highlightedMappingsMap: HighlightedMappingMapType,
    rowId: RowIdType,
    isDragging: boolean
): GetImportDescriptorStylingReturnType {
    const styles: Record<string, string> = {};
    styles['--confidence-color'] = getColorFromConfidence(confidence);

    let classes = 'import-descriptor confidence';

    if (highlightedMappingsMap.hasOwnProperty(rowId)) {
        classes = `${classes} confidence--highlighted`;
    }
    if (isDragging) {
        classes = `${classes} dragging`;
    }

    return { styles, classes };
}
